import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;
  height: 100vh;
  padding: 24px;
`
